import RecipeIngredient from '../RecipeIngredient';
import styles from './RecipeIngredients.module.scss';
import { IngredientGroups, RecipeIngredientItem } from 'types/api/recipe.types';
import { PrintFontOptions } from 'types/recipe';

type RecipeIngredientsProps = {
  recipeIngredientGroups: IngredientGroups[];
  recipeIngredientItems: RecipeIngredientItem[];
  siteKey: 'atk';
  viewContext: string;
  printSize?: PrintFontOptions;
};

const RecipeIngredients: React.FC<RecipeIngredientsProps> = ({
  recipeIngredientItems,
  viewContext,
  printSize,
}) => {
  const halfway = Math.ceil(recipeIngredientItems.length / 2);

  return (
    <>
      <div className={styles.column}>
        {recipeIngredientItems.slice(0, halfway).map((recipeIngredient) => {
          return (
            <RecipeIngredient
              key={recipeIngredient.id}
              recipeIngredientItem={recipeIngredient}
              viewContext={viewContext}
              printSize={printSize}
            />
          );
        })}
      </div>
      <div className={styles.column}>
        {recipeIngredientItems.slice(halfway).map((recipeIngredient) => {
          return (
            <RecipeIngredient
              key={recipeIngredient.id}
              recipeIngredientItem={recipeIngredient}
              viewContext={viewContext}
              printSize={printSize}
            />
          );
        })}
      </div>
    </>
  );
};

export default RecipeIngredients;
